$(document).ready(function () { 
  
  $('body').on('click', '.atc_color_redirect', function () {
    const $form = $(this).closest('form.shopify-product-form');
    const variant = $form.find('input[name="id"]').val();
    if (sessionStorage.getItem('salePdpVariant')) {
      sessionStorage.setItem('salePdpVariant', variant);
    } else {
      sessionStorage.setItem('salePdpVariant', variant);
    }
    window.location.href = '/pages/sale-pdp-color-chooser';
  });


if ((window.location.href.indexOf("sale-pdp-color-chooser") > -1)) {
    
  if (sessionStorage.getItem('salePdpVariant')) {
    const selectedVarID = sessionStorage.getItem('salePdpVariant');
    const selectedVarTitle = $(`variant-metacolor input[value="${selectedVarID}"]`).attr('data-title');
    const selectedVarRequiredColors = parseInt($(`variant-metacolor input[value="${selectedVarID}"]`).attr('data-free-colors'));
    $('#colorChooserHeading p').text($('#colorChooserHeading p').text().replace("Designs", selectedVarTitle));

    if (selectedVarTitle == '2 Designs') {
      $('.freegift_col').each(function(index) {
          if (index != 0) {
            $(this).removeClass('coladded');
            $(this).addClass('notAdded');
          } else {
            $(this).addClass('coladded');
            $(this).removeClass('notAdded');
          }
      })
      $('.kit-freegift [data-bundle="gifts-unlocked"]').text('1');
      $('[data-bundle="saving-pct"]').text('31');
    } else if (selectedVarTitle == '4 Designs') {
      $('.freegift_col').each(function(index) {
          if (index > 1) {
            $(this).removeClass('coladded');
            $(this).addClass('notAdded');
          } else {
            $(this).addClass('coladded');
            $(this).removeClass('notAdded');
          }
      })
      $('.kit-freegift [data-bundle="gifts-unlocked"]').text('2');
      $('[data-bundle="saving-pct"]').text('37');
    } else if (selectedVarTitle == '6 Designs') {
      $('.freegift_col').each(function(index) {
          if (index > 2) {
            $(this).removeClass('coladded');
            $(this).addClass('notAdded');
          } else {
            $(this).addClass('coladded');
            $(this).removeClass('notAdded');
          }
      })
      $('.kit-freegift [data-bundle="gifts-unlocked"]').text('3');
      $('[data-bundle="saving-pct"]').text('37');
    } else {
      $('.freegift_col').addClass('coladded');
      $('.freegift_col').removeClass('notAdded'); 
      $('.kit-freegift [data-bundle="gifts-unlocked"]').text('4'); 
      $('[data-bundle="saving-pct"]').text('46');  
        // if (selectedVarTitle == '4 Designs' || selectedVarTitle == '8 Designs') {
        //   $('[data-bundle="saving-pct"]').text('46');  
        // } else {
        //   $('[data-bundle="saving-pct"]').text('37');  
        // }  
    } 

    $('.addColorBtn').on('click', function() {
      $(this).closest('.cc_product_select').hide();
      const $parent = $(this).closest('.cc_product_select_inner');
      $parent.find('.product-form__quantity_top_block').show();
      $parent.find('input.quantity-selector__input').val(1);    
      checkColorsNumbers();
    })
  

    $('button.quantity-selector__button.quantity_minus').on('click', function() {
      const $parent = $(this).closest('.cc_product_select_inner');
      const quantitySelector = $parent.find('.quantity-selector__input');
      const inputVal = parseInt(quantitySelector.val());
      if (inputVal == 1) {
        quantitySelector.val(0);
        $parent.find('.cc_product_select').show();
        $parent.find('.product-form__quantity_top_block').hide();
      } else {
        quantitySelector.val(inputVal-1);
      }
      checkColorsNumbers();
    })

    $('button.quantity-selector__button.quantity_plus').on('click', function() {
      const $parent = $(this).closest('.cc_product_select_inner');
      const quantitySelector = $parent.find('.quantity-selector__input');
      const inputVal = parseInt(quantitySelector.val());
      const inputMax = parseInt(quantitySelector.attr('max'));
      if (inputVal != inputMax) {
        quantitySelector.val(inputVal+1);
      }
      checkColorsNumbers();
    })
    

  function checkColorsNumbers() {
    let totalQty = 0;
    $('.cc_product_main')
    .find('input.quantity-selector__input')
    .filter(function() {
      return $(this).val() !== '0';
    })
    .each(function () {
      totalQty += parseInt($(this).val(), 10);
    });


    // if (totalQty <= 2) {
    //   $('.kit-freegift [data-bundle="gifts-unlocked"]').text('0');
    // } else if (totalQty == 3) {
    //   $('.kit-freegift [data-bundle="gifts-unlocked"]').text('2');
    // } else if (totalQty == 4) {
    //   $('.kit-freegift [data-bundle="gifts-unlocked"]').text('3');
    // } else if (totalQty >= 5) {
    //   $('.kit-freegift [data-bundle="gifts-unlocked"]').text('4');
    // }

    if (totalQty >= selectedVarRequiredColors) {
      $('button#AddToCartColor').removeAttr('disabled');
      $('button#AddToCartColor .loader-button__text').text('BUY NOW →');      
    } else {
      $('button#AddToCartColor').attr('disabled', true);
      $('button#AddToCartColor .loader-button__text').text('Choose Designs →');
    }

    if (selectedVarTitle == '2 Designs' || selectedVarTitle == '4 Designs') {
      if (totalQty < 4) {
        $('.freegift_col').each(function(index) {
          if (index != 0) {
            $(this).removeClass('coladded');
            $(this).addClass('notAdded');
          } else {
            $(this).addClass('coladded');
            $(this).removeClass('notAdded');
          }
        })
        $('.kit-freegift [data-bundle="gifts-unlocked"]').text('1');
        $('[data-bundle="saving-pct"]').text('31');
      } else if (totalQty < 6) {
        $('.freegift_col').each(function(index) {
          if (index > 1) {
            $(this).removeClass('coladded');
            $(this).addClass('notAdded');
          } else {
            $(this).addClass('coladded');
            $(this).removeClass('notAdded');
          }
        })
        $('.kit-freegift [data-bundle="gifts-unlocked"]').text('2');
        $('[data-bundle="saving-pct"]').text('37');
      } else {
        $('.freegift_col').addClass('coladded');
        $('.freegift_col').removeClass('notAdded');  
        $('.kit-freegift [data-bundle="gifts-unlocked"]').text('4'); 
        $('[data-bundle="saving-pct"]').text('46');
        // if (totalQty == 4 || totalQty < 6) {
        //   $('[data-bundle="saving-pct"]').text('46');  
        // } else if (totalQty >= 6) {
        //   $('[data-bundle="saving-pct"]').text('37');  
        // }
      }
    } else {
      $('.freegift_col').addClass('coladded');
      $('.freegift_col').removeClass('notAdded');     
      $('.kit-freegift [data-bundle="gifts-unlocked"]').text('4'); 
      $('[data-bundle="saving-pct"]').text('46');  
      // if (selectedVarTitle == '4 Designs' || selectedVarTitle == '8 Designs') {
      //     $('[data-bundle="saving-pct"]').text('46');  
      // } else {
      //   $('[data-bundle="saving-pct"]').text('37');  
      // }
    }
    
  }

function generateUSETID() {
    var firstPart = (Math.random() * 46656) | 0;
    var secondPart = (Math.random() * 46656) | 0;
    firstPart = ("000" + firstPart.toString(36)).slice(-3);
    secondPart = ("000" + secondPart.toString(36)).slice(-3);
    return firstPart + secondPart;
}

function formatExpandedItemsToJsonArray(items) {
  const jsonArray = items.map(item => ({
    id: `gid://shopify/ProductVariant/${item.id}`,
    quantity: 1,
    customKey: item.price
  }));
  return JSON.stringify(jsonArray);
}


$('#AddToCartColor').on('click', async function(event) {
    event.preventDefault();
    event.stopPropagation();
    $(this).addClass('loading');
    $(this).attr('disabled', true);

    const $that = $(this);

    let totalQty = 0;
    let freeQty = 0;
    $('.cc_product_main')
    .find('input.quantity-selector__input')
    .filter(function() {
      return $(this).val() !== '0';
    })
    .each(function () {
      totalQty += parseInt($(this).val(), 10);
    });

    let items = [];
    
    if (totalQty >= 8) {
      items.push(parseInt($('variant-metacolor input[data-title="8 Designs"]').val()));
      freeQty = 8;
    } else if (totalQty >= 6) {
      items.push(parseInt($('variant-metacolor input[data-title="6 Designs"]').val()));
      freeQty = 6;
    } else if (totalQty >= 4) {
      items.push(parseInt($('variant-metacolor input[data-title="4 Designs"]').val()));
      freeQty = 4;
    } else {
      items.push(parseInt($('variant-metacolor input[data-title="2 Designs"]').val()));
      freeQty = 2;
    }
    
    $('.cc_product_main').find('input.quantity-selector__input').filter(function() {
      return $(this).val() !== '0';
    })
    .each(function () {
      const colorQty = parseInt($(this).val(), 10);
      const colorItem = $(this).closest('.cc_product[data-variant]')
      if (colorQty > 1) {
        for (let index = 0; index < colorQty; index++) {
          items.push(parseInt(colorItem.attr('data-variant')));
        }
      } else {
        items.push(parseInt(colorItem.attr('data-variant')));
      }
    });


    console.log('items', items);

    addRelated(items, $that, freeQty);
    
  });

}



async function addRelated(variantIdArray, $that, freeQty) {
  let set_id = generateUSETID();  

  let reduced_obj = variantIdArray.reduce(function(obj, b) {
      obj[b] = ++obj[b] || 1;
      return obj;
  }, {});

  let indexedObj = {};

    for (let i = 0; i < variantIdArray.length; i++) {
        indexedObj[i] = variantIdArray[i];
    }

    var product_data = [];
 
    let child_variant_ids = "";
    let free_variant_ids = "";


    let expandedItems =   [];


    Object.keys(indexedObj).forEach((key, index) => {
      if (index != 0) {
        const variantId = indexedObj[key];
        const colorItem = $('.cc_product_main').find(`.cc_product[data-variant="${variantId}"]`);
        const priceVar = parseInt(colorItem.attr('data-price'), 10) / 100;
        expandedItems.push({ id: variantId, price: priceVar });
        if (free_variant_ids == "") {
          free_variant_ids += variantId;
        } else {
          free_variant_ids += "," + variantId;
        }
      } 
    });
  
  
    Object.keys(reduced_obj).forEach((key, index) => {
        if (index != 0) {
          if (!child_variant_ids.includes(key)) {
              child_variant_ids += key + ":" + reduced_obj[key];
              child_variant_ids += '__';
          }
       } 
    });
  
  const expandJSON = formatExpandedItemsToJsonArray(expandedItems);
  
    $('.free_in_set_item.coladded:not(.notAdded)').each(function() {
      if ($(this).is(':visible')) {
        child_variant_ids += parseInt($(this).attr('data-variant')) + ":" + 1;
        child_variant_ids += '__';
      }
    });


      for (let key in indexedObj) {
        if (indexedObj.hasOwnProperty(key)) {
            if (key == 0) {
                let props = {};
                props['_refill-bundle-parent'] = true;
                props['_refill-bundle'] = true;
                props['_bundle-parent'] = true;
              if(window.atcPriceCompare != undefined) props['_compareOriginalPrice'] = window.atcPriceCompare;
                props['_refill-price'] = window.atcPrice;
                props['_set'] = set_id;
                props['_childItemsJson'] = expandJSON;
                props['_free_variants'] = free_variant_ids;
                let prod = { quantity: 1, id: parseInt(indexedObj[key]), properties: props };
                product_data.push(prod);
            }
        }
    }

  
    //   for (let key in indexedObj) {
    //     if (indexedObj.hasOwnProperty(key)) {
    //         if (key == 0) { 
    //               let indexCounter = 1;
    //               let props2 = {};
    //               $('.cc_product_main').find('input.quantity-selector__input').filter(function() {
    //                 return $(this).val() !== '0';
    //               })
    //               .each(function () {
    //                 const colorQty = parseInt($(this).val(), 10);
    //                 const colorItem = $(this).closest('.cc_product[data-variant]')
    //                 if (colorQty > 1) {
    //                   for (let index = 0; index < colorQty; index++) {
    //                      var color_string = "_Farbe_Img " + (indexCounter);
    //                     props2[color_string] = colorItem.attr('data-file');
    //                     var color_name= "_Farbe_Name " + (indexCounter);
    //                     props2[color_name] = colorItem.attr('data-name');
    //                     indexCounter += 1;
    //                   }
    //                 } else {
    //                   var color_string = "_Farbe_Img " + (indexCounter);
    //                   props2[color_string] = colorItem.attr('data-file');
    //                   var color_name= "_Farbe_Name " + (indexCounter);
    //                   props2[color_name] = colorItem.attr('data-name');
    //                   indexCounter += 1;
    //                 }
    //               });
    //                 props2['_bundle-parent'] = true;
    //                 props2['_set'] = set_id;
    //                 props2['_variants_set'] = child_variant_ids;
    //                 props2['_childItemsJson'] = expandJSON;
    //                 props2['_free_variants'] = free_variant_ids;
    //                 let prod2 = { quantity: 1, id: parseInt(indexedObj[key]), properties: props2 };
    //                 product_data.push(prod2);

    //         } else if (key > freeQty) {
    //                 let prod = { quantity: 1, id: parseInt(indexedObj[key]) };              
    //                 let colorPercentOff = parseInt($('variant-metacolor input[data-title="2 Designs"]').attr('data-optional-off'));
    //                 let originalPrice = parseFloat($(`.cc_product[data-variant="${parseInt(indexedObj[key])}"]`).attr('data-price')) / 100;
    //                 let offAmount = parseFloat(originalPrice * (colorPercentOff / 100));
             
    //                 prod["properties"] = {
    //                     '_bundled-product': true,
    //                     '_bundled-product-discount': true,
    //                     '_discountAmount': offAmount,
    //                     '_set_id': set_id
    //                 };
              
    //             product_data.push(prod);
    //         }
    //     }
    // }

  
      $('.free_in_set_item.coladded:not(.notAdded)').each(function() {
      if ($(this).is(':visible')) {
        let upsell_prod_opt = { quantity: 1, id: parseInt($(this).attr('data-variant')) };
        upsell_prod_opt["properties"] = {
            '_bundled-product': true,
            '_bundled-free': true,
            '_discountAmount': parseFloat($(this).attr('data-discount') / 100),
            '_set_id': set_id
        };
        product_data.push(upsell_prod_opt);
      }
    });

  console.log(product_data);

  
      async function addItemsToCartAndProceed() {
        try {

            const clearResponse = await fetch(`/cart/clear.js`, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'xmlhttprequest'
                }
            });
    
            if (!clearResponse.ok) {
                throw new Error("Error clearing the cart");
            }
          
            const response = await fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
                body: JSON.stringify({ items: product_data }),
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'xmlhttprequest'
                },
                method: 'POST'
            });

            const responseJson = await response.json();

            if (!response.ok) {
                throw new Error(responseJson["description"] || "Error adding items to cart");
                $that.removeClass('loading');
            }
            window.location.href = '/checkout';
            $that.removeClass('loading');
        } catch (error) {
          console.error(error);
          $that.removeClass('loading');
        }
    }
  
    addItemsToCartAndProceed();
  
}

  
  $('.color__media-list').on('mouseenter', function () {
          const $parent = $(this);
          if ($parent.length) {
              const $pageDots = $parent.find('.flickity-page-dots');
              if ($pageDots.length) {
                  const $secondDot = $pageDots.find('li:nth-child(2)');
                  if ($secondDot.length) {
                      $secondDot.trigger('click');
                  }
              }
          }
      });
  
  $('.color__media-list').on('mouseleave', function () {
      const $parent = $(this);
      if ($parent.length) {
          const $pageDots = $parent.find('.flickity-page-dots');
          if ($pageDots.length) {
              // Check hover state using DOM API
              if ($pageDots[0] && $pageDots[0].matches(':hover')) {
                  return;
              }
  
              const $firstDot = $pageDots.find('li:nth-child(1)');
              if ($firstDot.length) {
                  $firstDot.trigger('click');
              }
          }
      }
  });

  $('.cc_filter.tag-wrapper').on('click', function() {
    if ($(this).hasClass('fliter_active')) {
      $('.cc_filter.tag-wrapper').removeClass('fliter_active');
      $(`.cc_product_main`).show();
    } else {
      let formFilter = $(this).attr('data-value');
      $('.cc_filter.tag-wrapper').removeClass('fliter_active');
      $(this).addClass('fliter_active');
      $(`.cc_product_main`).hide();
      $(`.cc_product_main.pform_${formFilter}`).show();
    }
  })

    
} 
  
});